import { elementChildren } from '../../shared/utils.js';
export default function loopCreate(slideRealIndex) {
  var swiper = this;
  var {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  var slides = elementChildren(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
  slides.forEach((el, index) => {
    el.setAttribute('data-swiper-slide-index', index);
  });
  swiper.loopFix({
    slideRealIndex,
    direction: params.centeredSlides ? undefined : 'next'
  });
}